import styled from 'styled-components';

export const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.text.main};
  padding: 3rem 1.2rem;
  border-radius: 1rem;
  text-align: center;
  max-width: 39.5rem;
  position: relative;
  overflow: hidden;
  background: linear-gradient(113deg, #1C2538 55.59%, #3D63AE 101.05%);

  & > * {
    z-index: 10;
  }
`;

export const StyledTitle = styled.p`
  color: ${({ theme }) => theme.colors.text.main};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  font-size: ${({ theme }) => theme.fonts.sizes.large};
  line-height: 3.2rem;
  margin-bottom: 1.6rem;
  letter-spacing: -0.72px;

  span {
    color: ${({ theme }) => theme.colors.primary.main};
  }

  sup {
    font-size: ${({ theme }) => theme.fonts.sizes.small};
  }
`;

export const StyledTimerMessage = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  color: ${({ theme }) => theme.colors.text.main};
  padding-bottom: 1.1rem;
`;
